/**
 * Options type for the percent formatter function
 */
export type PercentFormatterOptions = {
  /**
   * The number of decimals to display
   * @default 2
   */
  decimals?: number;
  /**
   * The locale to use for the percent formatter
   * @default "en-US"
   */
  locale?: Intl.LocalesArgument;
};

/**
 * Helper function for formatting table cells with percentages, including i18n support
 * @param value - The value to format
 * @param options - The options for the percent formatter
 * @returns The formatted percentage
 */
export const percentFormatter = (
  value?: number,
  options: PercentFormatterOptions = {},
) => {
  const { decimals = 2, locale = "en-US" } = options;

  return value != null
    ? value.toLocaleString(locale, {
        style: "percent",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    : null;
};
